<!--
  - 页面顶端头部组件
  - 通用页面头部
-->

<template>
  <div class="BHeader">
    <h1 id="main_logo" @click="$router.push({name:'Index_index'})">ByteLang</h1>
    <div class="left">
      <ul>
        <li @click="Go(item)" :class="{'active' : IsActive(item.name)}" @mouseenter="enter_animate"
            v-for="item in left_menus"><span> {{item.title}} </span></li>
      </ul>
    </div>
    <div class="right">
      <ul class="right_menus">
        <li @click="Go(item)" :class="{'active' : IsActive(item.name)}" @mouseenter="enter_animate"
            v-for="item in right_menu"><span> {{item.title}} </span></li>
      </ul>
    </div>
  </div>
</template>

<script>
  import qs from "qs"
  import {mapGetters} from 'vuex'

  export default {
    name: 'BHeader',
    data(){
      return {
        //左侧菜单
        left_menus: [
          {
            title: '首页',
            name: 'Index_index',
            active: false,
          },
          {
            title: '代码在线运行',
            name: 'Build',
            active: false,
            params: {
              lang: 'php7',
            }
          },
          {
          	title: '在线SSH',
            name: 'OnlineSsh',
          	active: false,
          },
          {
            title: 'JSON格式化',
            name: 'ToolJson',
            active: false,
          },
          {
            title: 'Markdown编辑器',
            name: 'ToolMarkdown',
            active: false,
          },
          {
            title: '二维码在线识别',
            name: 'ToolQrcode',
            active: false,
          }
        ],
        right_menus: [
          {
            title: '登录',
            name: 'Login',
            active: false,
          },
          {
            title: '注册',
            name: 'Register',
            active: false,
          },
        ],
        right_menus_auth: [
          {
            title: '用户',
            name: 'DashboardMain',
            active: false,
          },
          {
            title: '注销',
            name: 'Logout',
            active: false,
          }
        ],
      }
    },
    computed: {
      ...mapGetters([
        'user',
        'token',
        'editor_status',
      ]),
      right_menu: {
        get: ()=>{
          let user = $vue.$store.getters.user;
          if(user instanceof Object){
            return [
              {title: user.username, name: 'DashboardCode'},
              {title: '注销', name: 'Logout'}
            ];
          }else{
            return [
              {title: '登录', name: 'Login'},
              {title: '注册', name: 'Register'}
            ];
          }
        }
      }
    },
    methods: {
      IsActive(name){
        return name === this.$route.name;
      },
      //进入动画
      enter_animate(event){
        $(event.target).find('span').animateCss('fadeInDown');
      },
      //链接跳转显示
      Go(item){
        this.$router.push({
          name: item.name,
          params: item.params,
        });
      },
    },
  }
</script>

<style scoped lang="less">
  @import "../../src/theme/default";

  .BHeader {
    display: flex;
    height: 100%;
    background: @header-background;
    padding: 0 10px;

    #main_logo {
      cursor: pointer;
    }

    //通用ul样式
    ul {
      height: @header_height;
      display: flex;
      padding: 0 10px;

      li {
        padding: 0 15px;
        text-align: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        color: white;
        cursor: pointer;
        border-bottom: 3px solid @header-background;
      }

      li.active {
        border-bottom: 3px solid @main-color;
      }
    }

    //右侧登录功能
    .right {
      display: flex;
      flex: 2;
      flex-direction: row-reverse;

      .user_menus {
        font-weight: 600;
        color: #3071a9;
      }
    }

    //左侧菜单
    .left {
      display: flex;
      flex: 8;
      flex-direction: row;
    }

    //左侧logo
    h1 {
      color: @main-color;
    }
  }
</style>
